import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import Wizard from 'scoreboard/components/wizard'
import ScoreboardDbStep1 from './scoreboard-db-step1'
import ScoreboardDbStep2 from './scoreboard-db-step2'
import ScoreboardDbStep3 from './scoreboard-db-step3'
import globals from 'scoreboard/components/globals'
import constants from 'scoreboard/components/constants'
import appDisplay from 'scoreboard/components/app-display'
import ErrorView from 'scoreboard/components/error-view'
import menuManager from 'scoreboard/menu-manager'

var ScoreboardDbWizard = Wizard.extend({

	/**
	 * The wizard used to add and edit databases in Admin | Databases.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Database} options.model the database
	 */
	initialize: function(options) {
		var type = options.model.get('type')
		var views = [ ScoreboardDbStep1, ScoreboardDbStep2 ]
		if (type === 'scoreboard') {
			views.push(ScoreboardDbStep3)
		}
		Wizard.prototype.initialize.call(this, _.extend({ views: views }, options))
	},

	finish: function() {
		var isNew = this.options.model.isNew()
		$.ajax({
			url: this.options.model.urlRoot,
			method: isNew ? 'put' : 'post',
			data: JSON.stringify(this.options.model.attributes),
			success: function(data) {
				this.options.model.set(data.database)

				// if we just added the first database
				if (isNew && !globals.database) {
					// this will populate the current database and license
					Backbone.trigger('load', data)
					// populate the org tree
					if (data.orgTree) {
						Backbone.trigger('load:orgTree', data.orgTree)
					}
					menuManager.operationalize()
				}

				this.trigger('done', this.options.model)
				var action = isNew ? 'add' : 'edit'
				Backbone.trigger(action + ':database', this.options.model)
			}.bind(this),
			error: function(xhr) {
				// if the provided connection info was bad, go back to the
				// previous step
				if (_.result(xhr, 'responseJSON.errors[0].messageCode') ===
					'admin.databaseConnections.saveError') {
					//this.back({ message: xhr.responseJSON.errors[0].message })
					this.trigger('connection-error', { message: xhr.responseJSON.errors[0].message })
				} else {
					this.trigger('error')
					appDisplay.dialog(new ErrorView(xhr.responseJSON))
				}
			}.bind(this)
		})

	}

})

export default ScoreboardDbWizard

ScoreboardDbWizard.__filename__ = 'admin/connections/scoreboard-db-wizard.js'
